module.exports = __webpack_public_path__ + "static/img/archibald_lightgrey_big.b221c6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/archibald_lightgrey_big.png
// module id = Ckeb
// module chunks = 1